<script>
  import contratoServico from '../servico';
  import { alert } from 'vue-strap';

  import ModalLiberarContrato from '~componentes/ModalLiberarContrato.vue';
  import ModalArquivosSolicitacao from '~componentes/ModalArquivosSolicitacao.vue';
  import ModalMensagem from '~componentes/ModalMensagem.vue';
  import Cabecalho from '~componentes/CabecalhoRelatorio.vue';
  
  export default {
    components: { alert, ModalLiberarContrato, ModalArquivosSolicitacao, ModalMensagem, Cabecalho},
    data() {
      return {
        carregando: true,
        contrato: {},
        permissaoLiberacao: false,
        modalLiberarContrato: false,
        modalArquivos: false,
        modalMensagem: false,
        solicitacaoSelecionada: null,
        contratoSelecionado: null,
        salvandoLiberacao: false,
        configuracao: this.$storage.configuracao(),
      }
    },
    methods: {
      permissaoLiberarContrato() {
        contratoServico
          .permissaoLiberarContrato(this.$route.params.id)
          .then(permissao => {

            this.permissaoLiberacao = permissao;
          })
          .catch(erro => {
            this.permissaoLiberacao = false;
          });
      },
      carregar() {
        this.carregando = true;
        
        return contratoServico
          .obterPorId(this.$route.params.id)
          .then(contrato => {
            this.carregando = false;

            this.contrato = contrato;
            this.permissaoLiberarContrato();
          });
      },
      liberar() {
        $('#liberar').button('loading');
        this.modalLiberarContrato = false;
        
        return contratoServico
          .liberar(this.$route.params.id)
          .then(() => {
            $('#liberar').button('reset');
            
            toastr.success(`Contrato liberado com sucesso.`);
            $('body').removeClass('modal-open');

            this.$router.push({ name: 'contrato' });
          })
          .catch(erro => {
            $('#liberar').button('reset');
            
            this.$mensagemErro(erro, 'Erro ao tentar liberar o contrato, ou usuário não possui permissão.');
          });
      },
      retornaDataFormatada(data) {
        if (data == null) {
          return '---';
        }

        return this.$options.filters.formatarData(data) + ' às ' +
          this.$options.filters.formatarHora(data);
      },
      retornaLiberadoNaoLiberado(liberado, tipo) {
        if (liberado == null)
          if (tipo == 't')
            return 'Não liberado';       
          else
            return 'fa fa-check-circle naoLiberado';

        if (liberado > 0)
          if (tipo == 't')
            return 'Liberado';       
          else
            return 'fa fa-check-circle liberado'
        else
          if (tipo == 't')
            return 'Não liberado';       
          else
            return 'fa fa-check-circle naoLiberado';   
      },
      
      mostrarModalLiberarContrato(contrato) {
        this.contratoSelecionado = contrato;
        this.modalLiberarContrato = true;
      },
      mostrarModalArquivos(solicitacao) {
        this.solicitacaoSelecionada = solicitacao;
        this.modalArquivos = true;
      },
      mostrarModalMensagem(solicitacao) {
        this.solicitacaoSelecionada = solicitacao;
        this.modalMensagem = true;
      },
      modalLiberarContratoFechado() {
        this.animated = false;
        this.modalLiberarContrato = false;
        this.contratoSelecionado = null;
      },
      modalArquivosFechado() {
        this.animated = false;
        this.modalArquivos = false;
        this.solicitacaoSelecionada = null;
      },      
      modalMensagensFechado() {
        this.animated = false;
        this.modalMensagem = false;
        this.solicitacaoSelecionada = null;
      },
      usuario1() {
        if (!this.contrato.contratoLiberacao)
          return '---';

        return (this.contrato.contratoLiberacao.usuario1) ? this.contrato.contratoLiberacao.usuario1.nome : '---';
      },
      usuario2() {
        if (!this.contrato.contratoLiberacao)
          return '---';

        return (this.contrato.contratoLiberacao.usuario2) ? this.contrato.contratoLiberacao.usuario2.nome : '---';
      },
      usuario3() {
        if (!this.contrato.contratoLiberacao)
          return '---';

        return (this.contrato.contratoLiberacao.usuario3) ? this.contrato.contratoLiberacao.usuario3.nome : '---';
      },
      usuarioContrato() {
        if (!this.contrato.contratoLiberacao)
          return '---';

        return (this.contrato.contratoLiberacao.usuarioContrato) ? this.contrato.contratoLiberacao.usuarioContrato.nome : '---';
      },
      retornaTipo(tipo) {
        switch (tipo) {
          case 1: return "Bolsa";
            break;
          case 2: return "RPA";
            break;
          case 3: return "Estágio";
            break;
          case 5: return "Adicional variável";
            break;
          default:
            return "Contrato";
            break;
        }
      },
      retornaTipoTitulo(tipo) {
        switch (tipo) {
          case 1: return "Bolsista";
            break;
          case 2: return "Autonômo";
            break;
          case 3: return "Estagiário";
            break;
          default:
            return "Contratada";
            break;
        }
      }
    },
    mounted() {
      this.$root.tituloDaPagina = 'Liberação de Contratos - Relatório';
      this.$root.botaoAcaoTexto = 'Imprimir relatório';
      this.$root.botaoAcaoIcon = 'fa-print';
      this.$root.botaoAcaoLink = '';
      this.$root.botaoAcaoMostrar = true;

      this.$root.botaoRetrocederMostrar = true;
      this.$root.botaoRetrocederRota = 'contrato';
      this.$root.filtrosBag = this.$route.params.filtrosBag;
      this.$root.tipo = this.$route.params.tipo;

      this.$events.on('botaoAcao', function () {
        window.print();
      });

      this.carregar(); 
      this.modalLiberarContrato = false;
    },
  }
</script>

<style scoped>
  .liberado {
    font-size: 1.35em;
    color: #1d9d74;
    margin-right: 3px;
  }

  .naoLiberado {
    font-size: 1.35em;
    color: #f5f5f5;
    margin-right: 3px;
  }
</style>

<template>
  <div :class="'wrapper wrapper-content animated ' + $root.animacaoPadrao">
    <modal-liberar-contrato :mostrar="modalLiberarContrato"
                            :id="contratoSelecionado ? contratoSelecionado.idContrato : ''"
                            :salvando="salvandoLiberacao"
                            @fechado="modalLiberarContratoFechado"
                            @liberar="liberar">
    </modal-liberar-contrato>

    <modal-arquivos-solicitacao :mostrar="modalArquivos"
                                :id="solicitacaoSelecionada ? solicitacaoSelecionada.idSolicitacaoWEB : ''"
                                tipo="bolsa"
                                @fechado="modalArquivosFechado">
    </modal-arquivos-solicitacao>

    <modal-mensagem :mostrar="modalMensagem"
                    :id="solicitacaoSelecionada ? solicitacaoSelecionada.idSolicitacaoWEBCrypt : ''"
                    :numero="solicitacaoSelecionada ? solicitacaoSelecionada.idSolicitacaoWEB : ''"
                    tipo="SolBolsa"
                    @fechado="modalMensagensFechado">
    </modal-mensagem>

    <div class="row">
      <div class="col-lg-12">
        <div class="ibox float-e-margins">
          <div class="ibox-content">

            <p v-show="carregando" class="text-center">
              <i class='fa fa-spinner fa-pulse'></i> Carregando...
            </p>

            <div v-if="!carregando">
              <cabecalho :titulo="'Contrato - Relatório'"></cabecalho>

              <h3 class="m-t-none m-b">Contrato: {{ contrato.codigoInterno }} | Sol. web: {{ contrato.idSolicitacaoWEB}}</h3>

              <div class="hr-line-dashed margin-top-5"></div>

              <div class="row">
                <div class="text-center">

                  <button type="button"
                          class="btn btn-success"
                          v-tooltip="'Enviar mensagem'"
                          @click="mostrarModalMensagem(contrato)"
                          v-if="!configuracao.naoUtilizarMensageria">
                    <i class="fa fa-comment"></i> Mensagens
                  </button>

                  <button type="button"
                          class="btn btn-info"
                          v-tooltip="'Listar ou adicionar arquivos da solicitação'"
                          @click="mostrarModalArquivos(contrato)"
                          v-if="configuracao.usarArquivosSolicitacaoBolsa">
                    <i class="fa fa-archive"></i> Arquivos
                  </button>

                  <button v-if="permissaoLiberacao"
                          class="btn btn-primary"
                          v-tooltip="'Liberar contrato'"
                          @click="mostrarModalLiberarContrato(contrato)">
                    <i class="fa fa-check"></i> Liberar contrato
                  </button>

                </div>
              </div>

              <div class="hr-line-dashed margin-top-5"></div>

              <div class="row">
                <dl class="col-xs-4">
                  <dt>Nome</dt>
                  <dd>{{ contrato.nomeContrato }}</dd>
                </dl>
                <dl class="col-xs-2">
                  <dt>Código interno</dt>
                  <dd>{{ contrato.codigoInterno }}</dd>
                </dl>
                <dl class="col-xs-2">
                  <dt>Código externo</dt>
                  <dd>{{ contrato.codigoExterno }}</dd>
                </dl>
                <dl class="col-xs-2">
                  <dt>Tipo</dt>
                  <dd>{{ retornaTipo(contrato.tipoContrato) }}</dd>
                </dl>
                <dl class="col-xs-2">
                  <dt>Valor contrato</dt>
                  <dd>{{ contrato.valor | formatarNumero }}</dd>
                </dl>
              </div>

              <div class="row">
                <dl class="col-xs-3">
                  <dt>Tipo de contrato</dt>
                  <dd>{{ contrato.tipoContratoObjeto ? contrato.tipoContratoObjeto.nome : '---' }}</dd>
                </dl>
                <dl class="col-xs-3">
                  <dt>Subtipo de contrato</dt>
                  <dd>{{ contrato.subTipoContratoObjeto ? contrato.subTipoContratoObjeto.nome : '---' }}</dd>
                </dl>
                <dl class="col-xs-2">
                  <dt>Data assinatura</dt>
                  <dd>{{ contrato.dataAssinatura | formatarNumeroEmData }}</dd>
                </dl>
                <dl class="col-xs-2">
                  <dt>Vigência início</dt>
                  <dd>{{ contrato.vigenciaContrato | formatarNumeroEmData }}</dd>
                </dl>
                <dl class="col-xs-2">
                  <dt>Vigência fim</dt>
                  <dd>{{ contrato.vigenciaContratoFim | formatarNumeroEmData }}</dd>
                </dl>
              </div>

              <div class="row">
                <dl class="col-xs-12">
                  <dt>Observação</dt>
                  <dd>{{ contrato.descricao }}</dd>
                </dl>
              </div>

              <div class="row">
                <dl class="col-xs-12">
                  <dt>{{ retornaTipoTitulo(contrato.tipoContrato) }}</dt>
                  <dd>{{ contrato.contratada ? contrato.contratada.nomePessoaFisicaJuridica + ' - ' + contrato.contratada.cpfCnpj : '---'  }}</dd>
                </dl>
              </div>

              <div class="hr-line-dashed margin-top-5"></div>

              <div class="bs-callout bs-callout-info no-margin-top" v-for="(projetoContrato, index) in contrato.projetoContratos">
                <div class="row">
                  <dl class="col-xs-12">
                    <dt>Projeto</dt>
                    <dd>{{ projetoContrato.projeto ? projetoContrato.projeto.nomeProjeto : '---' }}</dd>
                  </dl>
                </div>
              </div>

              <div class="hr-line-dashed margin-top-5"></div>

              <div class="row">
                <dl class="col-xs-1">
                  <dt>Liberação</dt>
                </dl>
                <dl class="col-xs-1">
                  <dt>LI</dt>
                </dl>
                <dl class="col-xs-2">
                  <dt>Data liberação</dt>
                </dl>
                <dl class="col-xs-4">
                  <dt>Usuário liberação</dt>
                </dl>
              </div>

              <div class="row">
                <dl class="col-xs-1">
                  <dd>Nível 1</dd>
                </dl>
                <dl class="col-xs-1">
                  <dd>
                    <i :class="[this.retornaLiberadoNaoLiberado(contrato.contratoLiberacao ? contrato.contratoLiberacao.idUsuarioNivel1 : null,'c')]"
                       v-tooltip="[this.retornaLiberadoNaoLiberado(contrato.contratoLiberacao ? contrato.contratoLiberacao.idUsuarioNivel1 : null,'t')]"
                       aria-hidden="true"></i>
                  </dd>
                </dl>
                <dl class="col-xs-2">
                  <dd>{{ (contrato.contratoLiberacao)  !== null ?  this.retornaDataFormatada(contrato.contratoLiberacao.dataHoraLiberacaoNivel1) : '---'   }}</dd>
                </dl>
                <dl class="col-xs-4">
                  <dd>{{  this.usuario1()  }}</dd>
                </dl>
              </div>

              <div class="row">
                <dl class="col-xs-1">
                  <dd>Nível 2</dd>
                </dl>
                <dl class="col-xs-1">
                  <dd>
                    <i :class="[this.retornaLiberadoNaoLiberado(contrato.contratoLiberacao ? contrato.contratoLiberacao.idUsuarioNivel2 : null,'c')]"
                       v-tooltip="[this.retornaLiberadoNaoLiberado(contrato.contratoLiberacao ? contrato.contratoLiberacao.idUsuarioNivel2 : null,'t')]"
                       aria-hidden="true"></i>
                  </dd>
                </dl>
                <dl class="col-xs-2">
                  <dd>{{ (contrato.contratoLiberacao)  !== null ?  this.retornaDataFormatada(contrato.contratoLiberacao.dataHoraLiberacaoNivel2) : '---'   }}</dd>
                </dl>
                <dl class="col-xs-4">
                  <dd>{{ this.usuario2()   }}</dd>
                </dl>
              </div>

              <div class="row">
                <dl class="col-xs-1">
                  <dd>Nível 3</dd>
                </dl>
                <dl class="col-xs-1">
                  <dd>
                    <i :class="[this.retornaLiberadoNaoLiberado(contrato.contratoLiberacao ? contrato.contratoLiberacao.idUsuarioNivel3 : null,'c')]"
                       v-tooltip="[this.retornaLiberadoNaoLiberado(contrato.contratoLiberacao ? contrato.contratoLiberacao.idUsuarioNivel3 : null,'t')]"
                       aria-hidden="true"></i>
                  </dd>
                </dl>
                <dl class="col-xs-2">
                  <dd>{{ (contrato.contratoLiberacao)  !== null ?  this.retornaDataFormatada(contrato.contratoLiberacao.dataHoraLiberacaoNivel3) : '---'   }}</dd>
                </dl>
                <dl class="col-xs-4">
                  <dd>{{ this.usuario3()  }}</dd>
                </dl>
              </div>

              <div class="row">
                <dl class="col-xs-1">
                  <dd>Contrato</dd>
                </dl>
                <dl class="col-xs-1">
                  <dd>
                    <i :class="[this.retornaLiberadoNaoLiberado(contrato.contratoLiberacao ? contrato.contratoLiberacao.idUsuarioContratoLiberado : null,'c')]"
                       v-tooltip="[this.retornaLiberadoNaoLiberado(contrato.contratoLiberacao ? contrato.contratoLiberacao.idUsuarioContratoLiberado : null,'t')]"
                       aria-hidden="true"></i>
                  </dd>
                </dl>
                <dl class="col-xs-2">
                  <dd>{{ (contrato.contratoLiberacao)  !== null ?  this.retornaDataFormatada(contrato.contratoLiberacao.dataContratoLiberado) : '---'   }}</dd>
                </dl>
                <dl class="col-xs-4">
                  <dd>{{ this.usuarioContrato() }}</dd>
                </dl>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>



// WEBPACK FOOTER //
// FrontEnd/modulos/contrato/componentes/Relatorio.vue